import React, { useEffect, useRef, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/reduxDispatch";
import {
  apiFetchSingleBot,
  apiMessageBot,
} from "../../../../services/apiCalls/user/chatbot";
import { setUserMessage } from "../../../../redux/reducers/userState/Chatbot";
import moment from "moment";
import { FiSend } from "react-icons/fi";
import TypingIndicator from "./typingIndicators";
import {
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router";
import { v4 as uuidv4 } from "uuid";
import { useSearchParams } from "react-router-dom";

const ChatbotMessaging = ({ botId }) => {
  const chattingSessionID = uuidv4();
  const [status, setStatus] = useState("loading");
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { chatMessage, singleBotdata } = useAppSelector((s) => s.userBot);
  const messagesEndRef = useRef(null);

  // for differentiating between iframe thing and local level
  const [localPath, setLocalPath] = useState(false);

  const processSingleClickedBot = (id) => {
    dispatch(apiFetchSingleBot(id, setStatus));
  };

  useEffect(() => {
    if (pathname === "/user/dashboard/bot/editBot") {
      setStatus("idle");
    } else {
      const botid = searchParams.get("botId");
      processSingleClickedBot(botid);
    }
    pathname === "/user/dashboard/bot/editBot"
      ? setLocalPath(true)
      : setLocalPath(false);
  }, [pathname]);

  console.log(pathname, singleBotdata);

  const scrollToBottom = () => {
    const chatContainer = messagesEndRef.current;
    if (chatContainer) {
      // Set the scrollTop to the height of the container
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  const [userText, setUserText] = useState("");

  const sendChatBotMessage = () => {
    setStatus("loading");
    setUserText("");
    const chatObj = {
      role: "user",
      content: userText,
    };

    const allChat = [...chatMessage, chatObj];

    dispatch(setUserMessage(allChat));
    // console.log(botId ? botId + "newbot" : "none");
    dispatch(
      apiMessageBot(
        {
          botId: botId ? botId : singleBotdata?.botId,
          userMessage: userText,
          convoId: chattingSessionID,
        },
        setStatus,
        allChat
      )
    );
  };

  //   console.log(chatMessage, "msggg");

  useEffect(() => {
    if (status === "success") {
      setStatus("idle");
    }
    scrollToBottom();
  }, [status]);

  return (
    // <div className="w-96">
    <div
      className={`z-[19999999] border border-gray-200 rounded-3xl shadow-inner bg-white shadow-xl w-full px-8 flex flex-col h-screen
      `}
    >
      {/* <div className=""> */}
      {/* Chat messages area */}
      {singleBotdata && (
        <div
          className={`flex border-b-2 item-center py-4 ${
            localPath ? "" : ""
          } bg-white right-8 left-8`}
        >
          <img
            src="/img/logo/i-2.png"
            alt="Logo"
            className="h-8 w-8 mr-2 sm:h-10 sm:w-10 rounded-full"
          />
          <div>
            <p>{singleBotdata?.botName}</p>
            <p className="text-sm mt-1">{singleBotdata?.botJob}</p>
          </div>
        </div>
      )}
      {singleBotdata && (
        <div
          className="overflow-y-auto flex-1 grow hide-scrollbar pb-10 mt-8 "
          ref={messagesEndRef}
          style={{ scrollBehavior: "smooth" }}
        >
          {/* Messages would be dynamically inserted here */}
          {chatMessage?.length > 0 &&
            chatMessage.map((msg, index) => {
              return (
                <div
                  key={index}
                  className={`p-4 my-4 rounded-lg ${
                    msg.role === "system"
                      ? "bg-cyan-800 text-white"
                      : " ml-auto text-gray-800 bg-gray-100"
                  }`}
                >
                  <p
                    className=""
                    style={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {msg.content}
                  </p>
                </div>
              );
            })}
        </div>
      )}
      <div>{status === "loading" && <TypingIndicator />}</div>
      {/* Input area */}
      {singleBotdata && (
        <div
          className={`flex border-t border-gray-300 ${
            localPath ? "" : ""
          } py-4`}
        >
          <input
            type="text"
            className="border flex-grow py-4 px-2 rounded-l-md focus:outline-none focus:ring"
            placeholder="Message.."
            value={userText}
            onChange={(e) => setUserText(e.target.value)}
          />
          <button
            className="bg-cyan-700 text-white rounded-r-md px-4 hover:bg-blue-600"
            onClick={sendChatBotMessage}
          >
            <FiSend />
          </button>
          {/* </div> */}
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default ChatbotMessaging;
